import { IMarkupObject } from "./IMarkupObject";

export enum LineType {
  Unknown,
  Solid = "solid",
  Dot = "dot",
  Dash = "dash",
}

export interface IMarkupLine extends IMarkupObject {
  getPoints(): number[];

  getLineWidth(): number;
  setLineWidth(size: number);

  getLineType(): string;
  setLineType(type: string);

  addPoints(points: [{ x: number; y: number }]);
}
